/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { exportTimeseriesRequestSchema } from '../campaign-schema';

export const exportTotalTimeseriesPathSchema = z.object({
  campaignId: z.string(),
});

export const exportTotalTimeseriesRequestBodySchema =
  exportTimeseriesRequestSchema;

export type ExportTotalTimeseriesInput = {
  path: z.input<typeof exportTotalTimeseriesPathSchema>;
  body?: z.input<typeof exportTotalTimeseriesRequestBodySchema>;
  signal?: AbortSignal;
};

export async function exportTotalTimeseries({
  path,
  body,
  signal,
}: ExportTotalTimeseriesInput): Promise<string> {
  const parsedPath = exportTotalTimeseriesPathSchema.parse(path);
  const parsedBody =
    body === undefined
      ? undefined
      : exportTotalTimeseriesRequestBodySchema.parse(body);

  const response = await socialApiClient.post(
    `campaigns/${parsedPath.campaignId}/exports/total-timeseries`,
    {
      signal,
      ...(parsedBody === undefined ? {} : { json: parsedBody }),
    },
  );
  return response.text();
}
